module.exports = __webpack_public_path__ + "img/mainEventEnd_moLogo_250604.1d15ac42.png";